<template>
  <Breadcrumbs
      title="Dealers"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealers', path: '/dealers' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <dealerListTable/>
    </div>
  </div>
</template>

<script>

import dealerListTable from "@/pages/master_data/dealers/dealerListTable.vue";

export default {
  components: {
    dealerListTable
  }
}

</script>